import { useCallback } from "react";
import { CouponsApi, useAPIAction } from "melco-shared-logic";

export const useDeactivateCoupons = () => {
  const [deactivateCoupons] = useAPIAction(
    CouponsApi,
    async (api, id: string) => {
      await api.couponsDeactivate({ id });

      return {
        successMessages: [{ message: "default" }],
        // data,
      };
    },
    {
      translationPrefix: "coupons.actions.deactivate",
    }
  );

  return useCallback(
    async (couponIds: string[]) => {
      const successfullyDeactivated: string[] = [];

      for (const couponId of couponIds) {
        try {
          await deactivateCoupons(couponId);
          successfullyDeactivated.push(couponId);
        } catch (e) {
          // error handling is already done in useAPIAction
        }
      }

      return successfullyDeactivated;
    },
    [deactivateCoupons]
  );
};
